<ng-template let-context let-modal="modal" #modalTemplate class="refresh-popup">
    <div class="content">
        <i class="exclamation circle red huge icon"></i>
        <h2>{{errorTitle}}</h2>
        <p>{{errorMessage}}</p>
    </div>
    <div class="actions">
        <button class="ui button" (click)="modal.deny('denied')">Ok</button>
    </div>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/generic/popup/errorPopup/errorPopup.html